/** The story of a job as the two agents told it, shown inside the job in the reader's language. */
export const talk = {
    "talk.title": "Agent's Conversation",
    "talk.request_mine": "Your agent sent your request to {name}.",
    "talk.request_theirs": "{name}'s agent sent a request to your agent.",
    "talk.asked_mine": "Your agent asked:",
    "talk.asked_theirs": "{name}'s agent asked:",
    "talk.answered_mine": "You answered:",
    "talk.answered_theirs": "{name} answered:",
    "talk.offer_mine": "Your agent offered {price}.",
    "talk.offer_theirs": "{name}'s agent offered {price}.",
    "talk.agreed": "The agents agreed on {price}.",
    "talk.signed_mine": "You signed.",
    "talk.signed_theirs": "{name} signed.",
    "talk.contacts": "Both signed, so your contact details were shared with each other.",
    "talk.ended": "The talk ended: {reason}",
    "talk.private_provider": "Your lowest price was never sent. It stayed on this phone.",
    "talk.private_requester": "Your budget was never sent. It stayed on this phone.",
    "decide.takeover_title": "Your agents could not agree",
    "decide.takeover_body": "After three offers each, it is your call. Their last offer: {price}.",
    "decide.accept_theirs": "Accept {price}",
    "decide.your_offer": "Your offer (₹)",
    "decide.send_offer": "Send my offer",
    "decide.end": "End the talk",
    "decide.time_title": "A different time",
    "decide.time_other": "{name} can come {when} instead of the time you asked for.",
    "decide.time_passed": "The time you asked for has passed.",
    "decide.time_passed_other": "The time you asked for has passed. {name} can come {when}.",
    "decide.accept_time": "Yes, {when}",
    "decide.pick_time": "Pick another time",
    "decide.pick_send": "Send this time",
    "a11y.takeover": "Your agents could not agree",
    "a11y.new_time": "A different time",
    "talks.take_over": "Take over from your agent",
};
//# sourceMappingURL=talk.js.map